import React from 'react';
import ProfilePlaceholder from 'assets/img/profile_placeholder.png';
import * as Ui from './AttributionBadge.styles';

const AttributionBadge = ({ attributedSource, sourceType }) => {
  const getName = () => {
    switch (sourceType) {
      case 'location':
        return attributedSource.name;
      case 'retailer':
        return `${attributedSource.name || ''} ${attributedSource.last_name || ''}`.trim();
      default:
        return null;
    }
  };

  const getImageUrl = () => {
    switch (sourceType) {
      case 'location':
        return attributedSource.logo;
      case 'retailer':
        return attributedSource.picture;
      default:
        return null;
    }
  };

  const name = getName();
  const publicUrl = attributedSource.public_url;
  const imageUrl = getImageUrl() || ProfilePlaceholder;

  const handleImageError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = ProfilePlaceholder;
  };

  return (
    <Ui.Container>
      <Ui.Image src={imageUrl} alt={name || ''} onError={handleImageError} />
      {publicUrl ? (
        <Ui.Link href={publicUrl} target="_blank" rel="noopener noreferrer">
          {name}
        </Ui.Link>
      ) : (
        <Ui.Name>{name}</Ui.Name>
      )}
    </Ui.Container>
  );
};

export default AttributionBadge;
